export const conditionOptions = [
  { value: 'new_with_tags', label: 'New with tags' },
  { value: 'like_new', label: 'Like new' },
  { value: 'great', label: 'Great' },
  { value: 'good', label: 'Good' },
];

export const countryOptions = [
  { value: 'Germany', label: 'Germany' },
  { value: 'France', label: 'France' },
  { value: 'Sweden', label: 'Sweden' },
  { value: 'United Kingdom', label: 'United Kingdom' },
];

export const countryCodeMap = {
  Germany: 'DE',
  France: 'FR',
  Sweden: 'SE',
  'United Kingdom': 'GB',
};
